// extracted by mini-css-extract-plugin
export default {"theme":"Theme_theme__E9DIX","wide":"Theme_wide__gxuyC","input":"Theme_input__ehEeI","inner":"Theme_inner__PcSd8","box":"Theme_box__nvSvn"};